import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon.jsx";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button.jsx";
import FormLayout from "../../../../Core/Layout/FormLayout.jsx";
import { usePostBrandMutation } from '../../../../store/api/barand_master.jsx';
import ApiResponseBox from '../../../../Components/ApiResponseBox.jsx';
import Tab1 from "./Tab1.jsx";
import { useLazyGetStockAccountsByCompanyQuery, useGetCompanyListQuery, useGetParentWarehousesQuery, useCreateWarehouseMutation, useLazyGetWarehouseByNameQuery, usePostWarehouseQueryMutation } from '../../../../store/api/warehousemaster.jsx';
import Attachment from '../../../../utils/Attachment.jsx';

function Updatewarehouse({ warehouseData }) {
  const navigate = useNavigate()
  const [tab, settab] = useState(1)
  const [res, setRes] = useState(false)
  const [brand, setBrand] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [showError, setShowError] = useState(false);
  const [postBrand] = usePostBrandMutation();
  const [parentcompany, setparentcompany] = useState([]);
  const [fullcompanylist, setfullcompanylist] = useState([]);
  const [accounts, setaccounts] = useState([]);


  const { data: companyList, isLoadingtwo } = useGetCompanyListQuery();

  const { data: parent_company, isLoading, isError } = useGetParentWarehousesQuery();

  console.log(parent_company, "parent_company");
  useEffect(() => {
    if (parent_company) {
      setparentcompany(parent_company);
    }
    if (companyList) {
      setfullcompanylist(companyList)
    }
  }, [parent_company]);



  // detail apicall
  const [DetailwarehouseData, setDetailWarehouseData] = useState(null);
  const [triggerGetWarehouse, { data: warehouseDetailData, isLoading: isWarehouseLoading, error: warehouseError }] =
    useLazyGetWarehouseByNameQuery();



  useEffect(() => {
    if (warehouseData?.name) {
      triggerGetWarehouse(warehouseData.name);
    }
  }, [warehouseData?.name]);

  useEffect(() => {
    if (warehouseDetailData) {
      setDetailWarehouseData(warehouseDetailData);
    }
  }, [warehouseDetailData]);

  console.log(DetailwarehouseData, "DetailwarehouseData");

  //   detail api call end

  useEffect(() => {
    if (warehouseDetailData) {
      setDetailWarehouseData(warehouseDetailData);

      // Pre-fill form data from the fetched warehouse detail
      setFormData({
        name: warehouseDetailData?.name || '',
        warehouseName: warehouseDetailData?.warehouse_name || '',
        parentWarehouse: warehouseDetailData?.parent_warehouse || '',
        company: warehouseDetailData?.company || '',
        account: warehouseDetailData?.account || '',
        abbr: warehouseDetailData?.custom_abbr || '',
        phoneNo: warehouseDetailData?.phone_no || '',
        mobileNo: warehouseDetailData?.mobile_no || '',
        addressLine1: warehouseDetailData?.address_line_1 || '',
        addressLine2: warehouseDetailData?.address_line_2 || '',
        county: warehouseDetailData?.custom_country || '',
        stateProvince: warehouseDetailData?.state || '',
        cityTown: warehouseDetailData?.city || '',
        postalCode: warehouseDetailData?.pin || '',
        isGroupWarehouse: warehouseDetailData?.is_group || false,
        isRejectedWarehouse: warehouseDetailData?.is_rejected_warehouse || false
      });

      if(warehouseDetailData?.company){
        handleSpecialFieldChange("company",warehouseDetailData?.company)
      }
    }
  }, [warehouseDetailData]);

  const [formData, setFormData] = useState({
    warehouseName: '',
    parentWarehouse: '',
    company: '',
    account: '',
    abbr: '',
    phoneNo: '',
    mobileNo: '',
    addressLine1: '',
    addressLine2: '',
    county: '',
    stateProvince: '',
    cityTown: '',
    postalCode: '',
    isGroupWarehouse: false,
    isRejectedWarehouse: false
  });

  const handleInputChange = (fieldName, value) => {
    console.log(fieldName, value, "fieldName, value");
    if (["company"].includes(fieldName)) {
      handleSpecialFieldChange(fieldName, value);
    }
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const [triggerGetStockAccounts] = useLazyGetStockAccountsByCompanyQuery();

  const handleSpecialFieldChange = (fieldName, value) => {
    console.log(`Special field changed: ${fieldName} -> ${value}`);

    if (fieldName === "company") {
      triggerGetStockAccounts(value)
        .unwrap()
        .then((data) => {
          console.log("Stock accounts for company:", data);
          setaccounts(data)

        })
        .catch((error) => {
          console.error("Error fetching stock accounts:", error);
        });
    }
  }
  // const [createWarehouse, { data, isLoadingthree, errorthree }] = useCreateWarehouseMutation();
  const [postWarehouseQuery, { data, isLoadingthree }] = usePostWarehouseQueryMutation();

  const handleSubmit = async () => {
    // Validate required fields
    if (!formData.warehouseName.trim()) {
      setError('Warehouse Name is required');
      setptype('Error');
      setShowError(true);
      return;
    }

    try {
      const warehouseName = warehouseData.name
      // Prepare complete payload from formData
      const payload = {
        // warehouse_name: formData.warehouseName,
        parent_warehouse: formData.parentWarehouse,
        company: formData.company,
        account: formData.account,
        custom_abbr: formData.abbr,
        phone_no: formData.phoneNo,
        mobile_no: formData.mobileNo,
        address_line_1: formData.addressLine1,
        address_line_2: formData.addressLine2,
        custom_country: formData.county,
        state: formData.stateProvince,
        city: formData.cityTown,
        pin: formData.postalCode,
        is_group: formData.isGroupWarehouse || false,
        is_rejected_warehouse: formData.isRejectedWarehouse || false,
      };

      console.log('Submitting payload:', payload);
      postWarehouseQuery({ warehouseName, payload })
        .unwrap()
        .then((res) => {
          console.log('Response:', res);
          setTimeout(() => {
            navigate('/master/warehouse-list')
          }, 1300);
        })
        .catch((err) => {
          console.error('Error:', err);
        });

    } catch (err) {
      setError(err?.data?.message || 'Failed to create warehouse');
      setptype('Error');
      setShowError(true);
    }
  };


  console.log(formData,"formDataformDataf ormDataformData");



  return (
    <>
      <FormLayout
        // title={formData.warehouseName}
        title={'Edit Warehouse'}


        breadcrumbs={[
          { label: "Master" },
          { label: "Warehouse List ", url: "/master/warehouse-list" }
        ]}
        status={'hide'}
        actionButtons={
          <>

            <Button
              className="custom-btn-00989"
              iconName="LuFilePlus2"
              style={{ gap: '2px', height: '28px' }}
              onClick={handleSubmit}
              iconSize={12}
            >
              Update
            </Button>

            <Button
              to="/brand/create-brand"
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            />
          </>
        }
      >
        <div className="mt-2" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end ">
              <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                  <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                    General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                  </a>
                </li>
              </ul>
              <Attachment doctype="Warehouse" docname={warehouseData.name} />
            </div>
          </div>
          <div className="mt-2 py-2" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", height: "500px" }}>
            <div className="row d-flex justify-content-between">
              <div className="col-12" >
                <div className="sidebarbox m-0 px-4 py-2">
                  <Tab1
                    parentcompany={parentcompany}
                    fullcompanylist={fullcompanylist}
                    accounts={accounts}
                    formData={formData}
                    onInputChange={handleInputChange}

                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ApiResponseBox
          poptype={ptype}
          show={showError}
          errorMessage={error}
          onClose={() => setShowError(false)}
        />
      </FormLayout>
    </>
  )
}

export default Updatewarehouse
